export function normalizeAccountNumber(accountNumber) {
  return accountNumber.replace(/[\s.]/g, '');
}
//# sourceMappingURL=normalizers.js.map